import React from 'react';

const statusStyles = {
  pending: {
    bg: 'bg-[#FFF8E1]',        // soft amber background
    text: 'text-[#FFB300]'     // amber text
  },
  completed: {
    bg: 'bg-[#E8F5E9]',        // soft green background
    text: 'text-[#2E7D32]'     // deep green text
  },
  cancelled: {
    bg: 'bg-[#FFEBEE]',        // soft red/pink background
    text: 'text-[#C62828]'     // rich red text
  },
  default: {
    bg: 'bg-gray-100',
    text: 'text-gray-700'
  },
    delivered: {
    bg: 'bg-[#E8F5E9]',        // soft green background
    text: 'text-[#2E7D32]'     // deep green text
  },
  scheduled: { bg: 'bg-[#F1DEFE]', text: 'text-[#5C46A8]' },
};




const Tags = ({ content }) => {
  const normalized = content?.toLowerCase().replace(/\s+/g, '_') || '';
  const { bg, text } = statusStyles[normalized] || statusStyles.default;

  return (
    <div
      className={`h-[30px] text-xs w-[100px] capitalize px-3 rounded-full font-semibold flex justify-center items-center ${bg} ${text}`}
    >
      {content || "-"}
    </div>
  );
};

export default Tags;
